import PubNub from 'pubnub';

const SUBSCRIBE_KEYS = {
  staging: 'sub-c-04fd056b-205c-4f0c-89d8-0489dd703805',
  production: 'sub-c-f5a5e4bf-0728-4faf-8848-bb42affa3f11',
};

const getSubscribeKey = () => {
  if (process.env.REACT_APP_ENV === 'staging') return SUBSCRIBE_KEYS.staging;
  if (process.env.NODE_ENV === 'production') return SUBSCRIBE_KEYS.production;
  return SUBSCRIBE_KEYS.staging;
};

let pubnubInstance = null;

export const initPubnub = userId => {
  if (!userId) return pubnubInstance;
  if (pubnubInstance && pubnubInstance.getUUID() === String(userId)) {
    return pubnubInstance;
  }
  if (pubnubInstance) teardown();
  pubnubInstance = new PubNub({
    subscribeKey: getSubscribeKey(),
    uuid: String(userId),
  });
  return pubnubInstance;
};

export const getPubnub = () => pubnubInstance;

window.getPubnub = getPubnub;

export const subscribe = channels => {
  if (!pubnubInstance || !channels?.length) return;
  pubnubInstance.subscribe({ channels });
};

export const teardown = () => {
  if (pubnubInstance) {
    pubnubInstance.unsubscribeAll();
    pubnubInstance = null;
  }
};
